import { falExternalLink } from 'shared/@generated/icons/falExternalLink';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Button } from 'shared/components/button';
import { Text } from 'shared/components/text';
import { clsx } from 'clsx';
import {
  formatPedigreeRegistrationId,
  isPedigreeChipNumber,
  type PedigreeRegistryLink,
} from 'shared/library/pedigree';

export function PedigreeId({
  registrationId,
  className,
}: {
  registrationId: string;
  className?: string;
}) {
  const { t } = useTranslation('components');

  return (
    <View className={clsx('max-w-full self-stretch rounded bg-stone-100 px-2 py-1', className)}>
      <Text className={'text-brand-brown-dark/50 text-xs'}>
        {t(`pedigree_id.${isPedigreeChipNumber(registrationId) ? 'chip' : 'registration'}`)}
      </Text>
      <Text className={'text-brand-brown-dark/80 text-sm font-bold tabular-nums'}>
        {formatPedigreeRegistrationId(registrationId)}
      </Text>
    </View>
  );
}

export function PedigreeRegistryButton({
  registryLink,
  className,
  testID,
}: {
  registryLink: PedigreeRegistryLink;
  className?: string;
  testID?: string;
}) {
  const { t } = useTranslation('components');

  return (
    <Button
      href={registryLink.href}
      openInNewTab={true}
      text={t('pedigree_id.view_pedigree')}
      color={'white'}
      dense={true}
      center={true}
      icon={falExternalLink}
      iconPosition={'left'}
      className={className}
      textClassName={'!text-sm'}
      testID={testID}
    />
  );
}
